// extracted by mini-css-extract-plugin
export default {"wrap":"NotFound_wrap__Lm5QC","note":"NotFound_note__rvSgm"};